'use client';

import { c as _c } from "react/compiler-runtime";
import ImgWrapper from '@components/img-wrapper/ImgWrapper';
import { getDateString } from '@lib/tools/_get_date_string';
import { handleBodyLock } from '@lib/tools/_handle-body-lock';
import { SCHEMA } from '@lib/tools/helpers/constants';
import { SafeHtmlRenderer } from '@lib/tools/helpers/SafeHtmlRenderer';
import Link from 'next/link';
import { useNewsUI } from '../NewsUIProvider';
import style from './NewsCard.module.scss';
export const NewsCard = t0 => {
  const $ = _c(24);
  const {
    item
  } = t0;
  const {
    saveScrollPosition
  } = useNewsUI();
  const date = item.createdAt;
  const imgUrl = item?.imagePreview ? item?.imagePreview : item?.fileUrl;
  const t1 = `/news/${item?.slug}`;
  let t2;
  if ($[0] !== imgUrl) {
    t2 = <div className={style.img}><ImgWrapper imgUrl={imgUrl} alt="background" className={style.backgroundImg} hasItemProp={true} /></div>;
    $[0] = imgUrl;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== item.title) {
    t3 = <div className={style.title} itemProp="headline">{item.title}</div>;
    $[2] = item.title;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== date) {
    t4 = getDateString(date);
    $[4] = date;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <div className={style.date}>{t4}</div>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t5) {
    t6 = <div className={style.text}>{t3}{t5}</div>;
    $[8] = t3;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== date) {
    t7 = <time dateTime={date} itemProp="datePublished" />;
    $[11] = date;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const t8 = item.content || item.title || "";
  let t9;
  if ($[13] !== t8) {
    t9 = <SafeHtmlRenderer tag="div" itemProp="description" className={style.descriptionHidden} content={t8} />;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t2 || $[16] !== t6 || $[17] !== t7 || $[18] !== t9) {
    t10 = <div className={style.content} itemScope={true} itemProp="blogPosts" itemType={SCHEMA.BLOG_POSTING}>{t2}{t6}{t7}{t9}</div>;
    $[15] = t2;
    $[16] = t6;
    $[17] = t7;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== saveScrollPosition || $[21] !== t1 || $[22] !== t10) {
    t11 = <Link href={t1} scroll={false} onClick={saveScrollPosition}>{t10}</Link>;
    $[20] = saveScrollPosition;
    $[21] = t1;
    $[22] = t10;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  return t11;
};